// extracted by mini-css-extract-plugin
module.exports = {"topWinnersBlock":"styles_topWinnersBlock__dK1pV","topWinnersContent":"styles_topWinnersContent__mjKC2","topWinnersTitle":"styles_topWinnersTitle__OpYDB"};